export default {
    name: 'MaterialCard',
    props: {
        data: {
            type: Object,
            required: true,
            default: {
                imageUrl: 'https://picsum.photos/500/700',
                title: 'Grundbog i små børns sorg Grundbog i små børns sorg Grundbog i små børns sorg Grundbog i små børns sorg',
                displayPrice: '139,-',
                url: 'https://www.dr.dk'
            }
        }
    },
    setup() {
        return {}
    }
}
